import { render, staticRenderFns } from "./IssueProbability.vue?vue&type=template&id=bd9cb108&scoped=true"
import script from "./IssueProbability.vue?vue&type=script&lang=js"
export * from "./IssueProbability.vue?vue&type=script&lang=js"
import style0 from "./IssueProbability.vue?vue&type=style&index=0&id=bd9cb108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9cb108",
  null
  
)

export default component.exports